import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Growth_Chart from "./popup";

const IndexSections = () => {
  const [growth_ChartModalOpen, setGrowth_ChartModalOpen] = useState(false);
  const openGrowth_Chart = () => setGrowth_ChartModalOpen(true);
  const closeGrowth_ChartModal = () => setGrowth_ChartModalOpen(false);
  return (
    <>
    
          <div className="snX"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1000">
              <div className="d-flex justify-content-between gap-1 align-items-center">
                <div>
                  <h2 className="gradient-stroke-text ">PTGC Growth Chart</h2>
                  <p>Monitor the percentage growth of PTGC and UFO compared to major cryptocurrencies across various time periods.</p>
                  <button onClick={openGrowth_Chart}  className="mybtn underline text-white mt-3 p-0"><span>View Now</span></button>
                </div>
                <div>
                  <div className="imgburn text-center"><img src="./images/logoIcon.svg" className="img-fluid" /></div>
                </div>
              </div>
          </div>



      <Growth_Chart modalIsOpen={growth_ChartModalOpen} closeModal={closeGrowth_ChartModal}
      />
    </>
  );
};

export default IndexSections;
